export default "__VITE_ASSET__56r2GWi0__"